export default [
  {
    id: 1,
    name: {
      en: "Home",
      nl: "Thuis"
    }
  },
  {
    id: 2,
    name: {
      en: "Work",
      nl: "Werk"
    }
  },
  {
    id: 3,
    name: {
      en: "Restaurant/Cafe",
      nl: "Restaurant/Cafe"
    }
  },
  {
    id: 4,
    name: {
      en: "On the Go",
      nl: "Onderweg"
    }
  },
  {
    id: 5,
    name: {
      en: "Friend's house",
      nl: "Vrienden"
    }
  },
  {
    id: 6,
    name: {
      en: "Family's house",
      nl: "Familie"
    }
  }
];
